module.exports = __webpack_public_path__ + "static/media/iStock-1159168752.5908307a.jpg";